import { FC, MouseEvent } from 'react';
import historyIcon from 'assets/icons/select-search-history.svg';
import { IOptionHistoryLabel } from 'features/searchSchedule/models/types';

import { ClearButton } from '../';

import styles from './styles.module.scss';

export const OptionHistoryLabel: FC<IOptionHistoryLabel> = ({
  value,
  styleImg,
  styleBtn,
  styleText,
  onClick,
}) => {
  return (
    <div className={styles['option']} key={value}>
      <div className={styles['option__content']}>
        <img
          className={styles['option__image']}
          src={historyIcon}
          alt="history"
          style={styleImg}
        />
        <span style={styleText}>{value.replace(/h_/g, '')}</span>
      </div>
      <ClearButton
        className={styles['option__button']}
        style={styleBtn}
        onClick={(e: MouseEvent<HTMLButtonElement>) => onClick(e, value)}
      />
    </div>
  );
};
